import { useCallback, useRef, useState } from 'react';
import { rollbar } from '../../../rollbarConfig';

export const HCAPTCHA_SITE_KEY = '66ba7e81-27b3-4067-a728-8a256a8e39d3';

/**
 * Invisible hCaptcha: widget stays mounted; token is fetched via execute() on submit.
 */
export default function useCaptcha() {
    const [captchaRemountKey, setCaptchaRemountKey] = useState(0);
    const captchaRef = useRef(null);

    const getCaptchaToken = useCallback(async () => {
        if (!captchaRef.current || typeof captchaRef.current.execute !== 'function') {
            return null;
        }
        try {
            const result = await captchaRef.current.execute({ async: true });
            return (result && result.response) || null;
        } catch (e) {
            rollbar.error('hCaptcha execute() failed to return a token', e);
            return null;
        }
    }, []);

    const resetCaptcha = useCallback(() => {
        setCaptchaRemountKey(prevCaptchaRemountKey => prevCaptchaRemountKey + 1);
    }, []);

    return {
        HCAPTCHA_SITE_KEY,
        captchaRef,
        captchaRemountKey,
        getCaptchaToken,
        resetCaptcha
    };
}
